import { motion } from "framer-motion";
import DelegateAccessCard from "../components/DelegateAccessCard";
import { Users2 } from "lucide-react";

export default function Team() {
  return (
    <div className="space-y-6" data-testid="team-page">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}>
        <p className="text-brand-sage font-bold text-sm tracking-wide uppercase flex items-center gap-2"><Users2 size={16} /> Equipo</p>
        <h1 className="font-outfit text-3xl sm:text-4xl font-extrabold text-brand-ink tracking-tight mt-1">Accesos de tu equipo</h1>
        <p className="text-muted-foreground mt-1 max-w-2xl">Genera y comparte los accesos QR + PIN para que tu asistente y tu enfermera trabajen desde su propio teléfono, sin ver la historia clínica.</p>
      </motion.div>
      <DelegateAccessCard />
    </div>
  );
}
